import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'

export const getMusicVersionLabel = (duration: number): string => {
  const minutes = Math.floor(duration / 60)
  const seconds = Math.floor(duration % 60)

  const secondsText = seconds === 1 ? translate(T.SECOND) : translate(T.SECONDS)
  const minutesText = minutes === 1 ? translate(T.MINUTE) : translate(T.MINUTES)

  if (minutes < 1) {
    return `${seconds} ${secondsText}`
  }

  if (seconds === 0) {
    return `${minutes} ${minutesText}`
  }

  return `${minutes} ${minutesText} ${seconds} ${secondsText}`
}
